<h1 mat-dialog-title>{{ data.title }}</h1>

<div mat-dialog-content>
    {{ data.message }}
</div>

<mat-dialog-actions align="end">
    @if (data.title != "Information")
    {
        <button type="button" mat-button (click)="onDismiss()">No</button>
        <button type="button" mat-raised-button color="accent" (click)="onConfirm()">Yes</button>
    }
    @else if (data.title == "Information")
    {
        <button type="button" mat-raised-button color="accent" (click)="onConfirm()">OK</button>
    }
</mat-dialog-actions>